import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import "./index.css";

const RecentSubgroups = ({ year }) => {
  const [recentSubgroups, setRecentSubgroups] = useState([]);

  useEffect(() => {
    // Get recent subgroups from localStorage
    if (year) {
      const stored = localStorage.getItem("recentSubgroups");
      if (stored) {
        setRecentSubgroups(JSON.parse(stored));
      }
    }
  }, [year]);

  const filteredRecentSubgroups = recentSubgroups.filter(
    (item) => item.year && item.year === year
  );

  return (
    <div className="recent-subgroups-container">
      <div className="recent-subgroups-wrapper">
        <div className="recent-label recent-bg">Recent:</div>
        <div className="subgroups-list">
          {filteredRecentSubgroups.map((subgroup) => (
            <Card
              key={subgroup.id}
              sx={{
                backgroundColor: "rgba(180, 167, 175, 0.6)",
                color: "white",
                minWidth: "fit-content",
              }}
              className="recent-bg"
            >
              <span className="subgroup-name">{subgroup.name}</span>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentSubgroups;
